export const isObjectEmpty = (objectName: any) => {
    return Object.keys(objectName).length === 0
}
